// extracted by mini-css-extract-plugin
module.exports = {"header":"Dtqp7Y","switch":"a-wC8a","title":"Ydi_0K"};